angular.module('lf.common')

.controller('SubscriptionMembershipCtrl', function ($scope, $injector, subscriptionService, gtmService) {
  var client = lf.data.xhr.client;
  var isDesktop = client.isDesktop || client.isLFC;
  var modals = $injector.get(isDesktop ? 'popupsService' : 'slideinService');
  
  $scope.subscriptionData = $.extend(true, {
    isActive: true,
    isCanceled: false
  }, lf.data.subscriptionData);
  
  $scope.showUpdateCreditCardModal = function showUpdateCreditCardModal () {
    modals.show('update-credit-card');
    gtmService.subscription.membership.trackUpdatePaymentMethodLinkClick();
  }
  
  $scope.showCancelMembershipModal = function showCancelMembershipModal () {
    modals.show('cancel-membership');
    gtmService.subscription.membership.trackCancelMembershipLinkClick();
  }
  
  $scope.goToRestartMembershipPage = function goToRestartMembershipPage () {
    window.location = lf.data.xhr.siteBaseUrl + '/subscription/restartMembership.jsp';
  }
  
});
